import { User, UserResponse } from './users-types'

export const mapUserResponseToUser = (userResponse: UserResponse): User => ({
  id: userResponse.id,
  email: userResponse.email,
  nameFirst: userResponse.name_first,
  nameLast: userResponse.name_last,
  organizationId: userResponse.organization_id,
  role: userResponse.role,
})
